const FormItem = ({label = null, children, htmlFor = ''}) => (
  <div className="flex flex-col gap-[6px] justify-start">
    {label && <label htmlFor={htmlFor}>{label}</label>}
    {children}
  </div>
);

export default FormItem;
